/**
 * Wszystkie zakładki panelu (ścieżki Router + etykiety w formularzu użytkownika).
 * Kolejność = kolejność checkboxów i domyślne pierwsze przekierowanie po zalogowaniu.
 */
export const PANEL_ROUTE_OPTIONS = [
  { path: '/dashboard', label: 'Dashboard' },
  { path: '/news', label: 'Aktualności' },
  { path: '/events', label: 'Wydarzenia' },
  { path: '/reports', label: 'Zgłoszenia' },
  { path: '/attractions', label: 'Atrakcje' },
  { path: '/interactive-map/places', label: 'Mapa — miejsca' },
  { path: '/interactive-map/categories', label: 'Mapa — kategorie' },
  { path: '/waste-schedule', label: 'Harmonogram odpadów' },
  { path: '/segregacja', label: 'Segregacja' },
  { path: '/contact', label: 'Kontakt' },
  { path: '/alarm-systems', label: 'Systemy alarmowe / OCiZK (nazwa edytowalna)' },
  { path: '/chat-assistant', label: 'Asystent (chat) / FAQ' },
  { path: '/app-settings', label: 'Wygląd aplikacji' },
  { path: '/push-notifications', label: 'Powiadomienia push' },
  { path: '/manage', label: 'Zarządzanie (zakładki aplikacji)' },
  { path: '/users', label: 'Użytkownicy panelu' },
  { path: '/status-requests', label: 'Prośby o zmianę statusu' },
  { path: '/audit-log', label: 'Dziennik zdarzeń' },
  { path: '/visit-counts', label: 'Liczba odwiedzin' },
];

const ALL_PANEL_PATHS = PANEL_ROUTE_OPTIONS.map((o) => o.path);

/** Domyślne ścieżki wg roli, gdy panel_allowed_routes IS NULL (zgodnie z Layout.js). */
const LEGACY_ROLE_TO_PATHS = {
  admin: ALL_PANEL_PATHS,
  moderator: ['/news', '/events', '/attractions', '/audit-log'],
  support: ['/reports', '/audit-log'],
  secretary: ['/reports', '/push-notifications', '/audit-log'],
};

export function getLegacyRoutesForRole(role) {
  return [...(LEGACY_ROLE_TO_PATHS[role] || [])];
}

export function getEffectiveAllowedRoutes(user) {
  if (!user) return [];
  if (user.role === 'admin') return ALL_PANEL_PATHS;
  if (Array.isArray(user.panel_allowed_routes)) {
    const valid = new Set(ALL_PANEL_PATHS);
    return user.panel_allowed_routes.filter((p) => valid.has(p));
  }
  return getLegacyRoutesForRole(user.role);
}

export function userCanAccessPanelPath(user, path) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  return getEffectiveAllowedRoutes(user).includes(path);
}

export function getDefaultPathForUser(user) {
  if (!user) return '/login';
  const routes = getEffectiveAllowedRoutes(user);
  if (routes.length === 0) return '/login';
  return routes[0];
}
